export default __webpack_public_path__ + "static/media/Hexicon-Hand-Rub-250-ml.00d33890.jpg";